import { Image, Parse } from '@/components/Core'
import TeamCardFragment from '@/lib/fragments/team-member'
import { Lib } from '@/types'
import { MEDIA } from '@config'
import clsx from 'clsx'
import { HTMLAttributes, memo } from 'react'

export interface CardTeamProps extends HTMLAttributes<HTMLDivElement> {
  data: Lib.FragmentOf<typeof TeamCardFragment>
}

const CardTeam = ({ data, className, ...props }: CardTeamProps) => {
  const { image, name, description, role } = data

  return (
    <div
      className={clsx(
        className,
        'gap-md p-sm flex h-full flex-col rounded-lg bg-neutral-200'
      )}
      {...props}
    >
      <Image
        data={image}
        wrap={{ className: 'w-full' }}
        fitWrap
        imgClassName="rounded-md w-full !max-w-full"
        sizes={`${MEDIA.sm} 20rem, 40rem`}
        ar="1x1"
      />
      <div className="px-sm gap-md grid h-full grid-rows-[1fr_auto]">
        <div>
          <h3>{name}</h3>
          {description && (
            <div className="text-style-large mt-md">
              <Parse html={description} />
            </div>
          )}
        </div>
        <div className="text-neutral-600">{role}</div>
      </div>
    </div>
  )
}

export default memo(CardTeam)
